import React from 'react';
import RootWrapper from 'pages/RootWrapper';
import { Provider } from 'react-redux';
import Store from './store';

import './App.less';

function App() {
  return (
    <Provider store={Store}>
      <div className="main">
        {/* RootWrapper, for Login page and the MainLayout */}
        <RootWrapper />
      </div>
    </Provider>
  );
}

export default App;
